export const environment: any = {
	BASE_URL: '/api',
	production: true,
	environment: 'production',
	sentry: true,
	jawgAccessToken: 'zyTdG32yqt0T6ncgVT1J5ScQfcQ91qU5OrwfOqO6NVkVP0QiNWJJgEKbIfIXChPB',
	recaptcha: '6Lc2kRArAAAAACHcpwrvmT5WThS1w6_WTQ6GouGJ',
};
